import { render, staticRenderFns } from "./BrandTabs.vue?vue&type=template&id=249027c5&scoped=true&"
import script from "./BrandTabs.vue?vue&type=script&lang=js&"
export * from "./BrandTabs.vue?vue&type=script&lang=js&"
import style0 from "./BrandTabs.vue?vue&type=style&index=0&id=249027c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249027c5",
  null
  
)

export default component.exports